
import React from "react";


export default function BrandSearch({ model, images, delebiler, seoContent,heading }) {
    const [searchTerm, setSearchTerm] = React.useState('');
    const lettersAndBrandsObject = JSON.parse(model);

    const getBrands = (brands) => {
        return brands
            .filter(brand => brand.Brand.toLowerCase().includes(searchTerm.toLowerCase()))
            .map((brand) => {
                const imageUrl = images?.find(image => image.Item1 === brand.BrandId);
                const brandName = brand.Brand;
                

                // Defensive check for image URL
                const imgSrc = imageUrl ? imageUrl.Item2 : null;

                return (
                    <li key={brand.BrandId}>
                        <a
                            className={`brandListItem ${searchTerm?.length>1 ? 'brandListItemFiltered' : ''}`}
                            href={delebiler ? `Delebiler/${brand.Slug}` : `Bildeler/${brand.Slug}`}
                        >
                            <div className="brandListItemContent">
                                <div className="brandListItemImageWrapper">
                                    {imgSrc && <img className="brandListItemImage" src={imgSrc} alt={brand.Brand} />}
                                </div>
                                <h2 className="brandListItemTitle">
                                    {brandName}
                                   
                                </h2>
                            </div>
                        </a>
                    </li>
                );
            });
    };

    const getLetterAndBrands = (lettersAndBrands) => {
        
                    const allBrandLis = [];

            Object.entries(lettersAndBrands).sort().forEach(([letter, brands]) => {
            const filteredBrands = getBrands(brands);
            if (filteredBrands.length === 0) return;
            // Add id to the first <li> of each group
            filteredBrands.forEach((child, idx) => {
                if (idx === 0) {
                    allBrandLis.push(React.cloneElement(child, { id: letter }));
                } else {
                    allBrandLis.push(child);
                }
            });
        });
        return allBrandLis;
    };

    

    return (
        <div className="accordionContent">
            <div className="columnLeft">
                <div className="brandSearchInputWrapper">
                    <div className="searchInputContainer">
                        <input
                            placeholder="Søk bilmerke"
                            className="searchBrandByLetterInput"
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                        />
                        <img src="/images/search.png" alt="Search" className="searchImage" />
                    </div>
                    <div className="searchBrandByLetterWrapper">
                        <div className="searchBrandByLetterButtonWrapper">
                            {Object.entries(lettersAndBrandsObject).sort().map(([letter]) => {
                                return (
                                    <button className="searchBrandByLetterButton" key={letter}>
                                        <a className="searchBrandByLetteButtonLink" href={`#${letter}`}>{letter}</a>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <h1>{heading}</h1>
                {seoContent?.Value &&
                <div className="seoContent" dangerouslySetInnerHTML={{ __html: seoContent?.Value }}></div>
                    }

            </div>
            <ul className="innerBrandList">
                {getLetterAndBrands(lettersAndBrandsObject)}
            </ul>
        </div>
    );
}
